const styles = {
  container: {},
  main: {
    display: "flex",
    gap: "1rem",
    width: "60%",
  },
  leftMain: {
    flex: 1,
    minWidth: 260,
  },
  rightMain: {
    flex: 2,
    minWidth: 260,
  },
  btnContainer: {
    display: "flex",
    gap: "2rem",
    marginTop: "2rem",
  },
  inputWrapper: {
    display: "flex",
    marginTop: "0.5rem",
    minWidth: "243px",
    padding: "24px 24px 34px 24px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "10px",
    borderRadius: "8px",
    border: "1px solid #E0DEDE",
    backgroundColor: "rgba(224, 222, 222, 0.20)",
    height: "90%",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #9DCBC6",
    borderRadius: "4px",
    padding: "8px",
    marginBottom: "8px",
    cursor: "pointer",
    background: "#F2FCFB",
    width: "100%",
  },
  icon: {
    cursor: "pointer",
    marginRight: "16px",
    fontSize: "10px",
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    marginTop: "2rem",
  },
  btn: {
    display: "flex",
    gap: "2rem",
    marginTop: "3rem",
  },
  pagination: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    margin: "30px 0",
    padding: "0 1rem",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export default styles;
